import { formatCardNumber, formatPhoneNumber } from '~/shared/lib/formatter';
import { orderStatuses, publicStatuses } from '../constants';
import { Bank, type PublicStatus, type Status } from '../model';

export const formatOrder = {
    date: (dateString?: string) => {
        if (!dateString) {
            return '';
        }

        return new Date(dateString).toLocaleString();
    },
    bank: (bank?: Bank) => {
        if (!bank) {
            return '';
        }

        if (typeof bank !== 'string') {
            return 'BIN банка не определен';
        }

        if (bank === Bank.BANK_UNSPECIFIED) {
            return 'Не указан';
        }

        return bank.replace('BANK_', '').replaceAll('_', ' ');
    },
    status: (status: Status) => {
        const { label } =
            orderStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label || '';
    },
    publicStatus: (status: PublicStatus) => {
        const { label } =
            publicStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label || '';
    },
    currency: (currency?: string) => {
        if (!currency) {
            return '';
        }

        return currency.replace('CURRENCY_', '');
    },
    type: (type: string) => {
        return type.replace('TYPE_', '').replaceAll('_', ' ');
    },
    cardNumber: formatCardNumber,
    phoneNumber: formatPhoneNumber,
} as const;
